import * as React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import ReactGA from 'react-ga';
import history from './helpers/history';
import './App.css';

import Client from './client';
import Login from './client/login';
import Public from './public';
import { CLIENT_PATH, PUBLIC_PATH, TRACKER, EMBED_PATH } from './constants';
import ScrollToTop from './shared/ScrollToTop';

if (TRACKER) {
    ReactGA.initialize(TRACKER);
    history.listen(location => ReactGA.pageview(location.pathname));
}

export default () => (
    <Router history={history}>
        <React.Fragment>
            <ScrollToTop>
                <Switch>
                    <Route path={CLIENT_PATH} component={Client} />
                    <Route path={[PUBLIC_PATH, EMBED_PATH]} component={Public} />
                    <Route path="/" component={Login} />
                </Switch>
            </ScrollToTop>
        </React.Fragment>
    </Router>
);



// WEBPACK FOOTER //
// ./src/App.tsx